import React, { useState, useEffect } from 'react';
import PlaceholderImage from "../resources/elementor-placeholder-image.webp";
import { doc, setDoc } from "firebase/firestore"; 
import { db, storage } from "../firebase/firebaseConfig";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";
import { useNavigate } from 'react-router-dom';
import NewPlaceholderImage from "../resources/new-placeholder.jpg"

const CreateGroup = (e) => {
  const navigate = useNavigate();
  
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [publicGroup, setPublicGroup] = useState("");
  const [groupManagers, setGroupManagers] = useState("");
  const [visibility, setVisibility] = useState("");
  const [featuredImage, setFeaturedImage] = useState(null); 
  const [placeholderImage, setPlacholderImage] = useState(NewPlaceholderImage);

  const generateId = () => {
    return [...Array(20)].map(() => Math.random().toString(36)[2]).join('');
  };

  const uploadImage = () => {
    return new Promise((resolve, reject) => {
      const imageRef = storageRef(storage, `${generateId()}`);

      uploadBytes(imageRef, featuredImage)
        .then((snapshot) => {
          console.log("Image uploaded successfully");

          getDownloadURL(snapshot.ref)
            .then((url) => {
              console.log("Download URL: ", url);
              resolve(url); 
            })
            .catch((error) => {
              console.error("Error getting download URL: ", error);
              reject(error); 
            });
        })
        .catch((error) => {
          console.error("Error uploading image: ", error);
          reject(error); 
        });
    });
  };

  const createMyGroup = async (e) => {
    e.currentTarget.innerHTML = "Creating Group...";
    e.target.style.cursor = "wait";

    const id = generateId();

    try {
      const imageUrl = await uploadImage();

      await setDoc(doc(db, "Groups", id), {
        Title: title,
        Description: description,
        PublicGroup: publicGroup,
        GroupManagers: groupManagers,
        Visibility: visibility,
        FeaturedImage: imageUrl,
        Members: 0,
      });

      console.log("Group successfully created!");

    } catch (error) {
      console.error("Error creating group: ", error);
    }

    navigate('/groups');
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setPlacholderImage(URL.createObjectURL(file));
    setFeaturedImage(file);
  };

  return (
    <div id='content'>
      <h1>Create Group</h1>
        <div className='row'>
            <div className='col-sm-8'>
                    <h4>Basic Info</h4>
                    <label>Group Title
                    <br/> <input type="text" onChange={(e) => setTitle(e.target.value)}/></label>
                    <label>Group Description
                    <br/> <textarea onChange={(e) => setDescription(e.target.value)}/></label>
                    <label className='checkbox-label'><input type="checkbox" onChange={(e) => setPublicGroup(e.target.value)}/> Public Group</label>
                    <label>Group Managers
                    <br/> <input type="text" onChange={(e) => setGroupManagers(e.target.value)}/></label>
                    <select onChange={(e) => setVisibility(e.target.value)}>
                        <option value="Open - Anyone can Join">Open - Anyone can Join</option>
                        <option value="Closed - Invites Only">Closed - Invites Only</option>
                    </select>

                    <br/>
                    <br/>
                    <br/>
                    
                <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start'}}>
                    <button onClick={(e) => createMyGroup(e)}>Create Group</button>
                </div>
            </div>
            <div className='col-sm-4' style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingRight: '50px'}}>
                <img src={placeholderImage} width="75%"/>
                <label style={{ cursor: 'pointer', textAlign: 'right'}}  htmlFor="file-upload" className="custom-file-upload">
                    <b>Change Featured Image</b>
                </label>
                <input
                    id="file-upload"
                    type="file"
                    onChange={handleImageChange}
                    style={{ display: 'none' }} 
                />
            </div>
        </div>
    </div>
  );
}

export default CreateGroup;
